import _regeneratorRuntime from "@babel/runtime/regenerator";

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { Promise.resolve(value).then(_next, _throw); } }

function _asyncToGenerator(fn) { return function () { var self = this, args = arguments; return new Promise(function (resolve, reject) { var gen = fn.apply(self, args); function _next(value) { asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value); } function _throw(err) { asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err); } _next(undefined); }); }; }

function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }

function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

function _iterableToArrayLimit(arr, i) { if (typeof Symbol === "undefined" || !(Symbol.iterator in Object(arr))) return; var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"] != null) _i["return"](); } finally { if (_d) throw _e; } } return _arr; }

function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from 'react';
import { useForm } from '../../contexts/form/form.es.js';
import { useEventListener } from '../../hooks/use-event-listener.es.js';
import { ApplePayContainer } from './apple-pay.styles.es.js';

function ApplePay(_ref) {
  var _ref$id = _ref.id,
      id = _ref$id === void 0 ? "rswps-apple-pay" : _ref$id,
      props = _objectWithoutProperties(_ref, ["id"]);

  var _React$useState = React.useState(function () {
    return void 0;
  }),
      _React$useState2 = _slicedToArray(_React$useState, 2),
      applePay = _React$useState2[0],
      setApplePay = _React$useState2[1];

  var _useForm = useForm(),
      cardTokenizeResponseReceived = _useForm.cardTokenizeResponseReceived,
      createPaymentRequest = _useForm.createPaymentRequest,
      payments = _useForm.payments;

  var containerRef = React.useRef(null);

  var handlePayment = /*#__PURE__*/function () {
    var _ref2 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee(e) {
      var result, message;
      return _regeneratorRuntime.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              e.stopPropagation();

              if (applePay) {
                _context.next = 4;
                break;
              }

              console.warn("Apple Pay button was clicked, but no Apple Pay instance was found.");
              return _context.abrupt("return");

            case 4:
              _context.prev = 4;
              _context.next = 7;
              return applePay.tokenize();

            case 7:
              result = _context.sent;

              if (!(result.status === "OK")) {
                _context.next = 10;
                break;
              }

              return _context.abrupt("return", cardTokenizeResponseReceived(result));

            case 10:
              message = "Tokenization failed with status: ".concat(result.status);

              if (!(result === null || result === void 0 ? void 0 : result.errors)) {
                _context.next = 14;
                break;
              }

              message += " and errors: ".concat(JSON.stringify(result === null || result === void 0 ? void 0 : result.errors));
              throw new Error(message);

            case 14:
              console.warn(message);
              _context.next = 20;
              break;

            case 17:
              _context.prev = 17;
              _context.t0 = _context["catch"](4);
              console.error(_context.t0);

            case 20:
            case "end":
              return _context.stop();
          }
        }
      }, _callee, null, [[4, 17]]);
    }));

    return function handlePayment(_x) {
      return _ref2.apply(this, arguments);
    };
  }();

  React.useEffect(function () {
    if (!createPaymentRequest) {
      throw new Error("`createPaymentRequest()` is required when using digital wallets");
    }

    var abortController = new AbortController();
    var signal = abortController.signal;

    var start = /*#__PURE__*/function () {
      var _ref3 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee2(signal2) {
        var paymentRequest, applePay2;
        return _regeneratorRuntime.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                paymentRequest = payments === null || payments === void 0 ? void 0 : payments.paymentRequest(createPaymentRequest);

                if (paymentRequest) {
                  _context2.next = 3;
                  break;
                }

                throw new Error("`paymentRequest` is required when using digital wallets");

              case 3:
                _context2.prev = 3;
                _context2.next = 6;
                return payments === null || payments === void 0 ? void 0 : payments.applePay(paymentRequest).then(function (res) {
                  if (signal2 === null || signal2 === void 0 ? void 0 : signal2.aborted) {
                    return;
                  }

                  setApplePay(res);
                  return res;
                });

              case 6:
                applePay2 = _context2.sent;

                if (!signal2.aborted) {
                  _context2.next = 10;
                  break;
                }

                _context2.next = 10;
                return applePay2 === null || applePay2 === void 0 ? void 0 : applePay2.destroy();

              case 10:
                _context2.next = 15;
                break;

              case 12:
                _context2.prev = 12;
                _context2.t0 = _context2["catch"](3);
                console.error("Initializing Apple Pay failed", _context2.t0);

              case 15:
              case "end":
                return _context2.stop();
            }
          }
        }, _callee2, null, [[3, 12]]);
      }));

      return function start(_x2) {
        return _ref3.apply(this, arguments);
      };
    }();

    start(signal);
    return function () {
      abortController.abort();
    };
  }, [createPaymentRequest, payments]);
  useEventListener({
    listener: handlePayment,
    type: "click",
    element: containerRef,
    options: {
      passive: true
    }
  });
  return /* @__PURE__ */React.createElement(ApplePayContainer, _objectSpread(_objectSpread({}, props), {}, {
    css: {
      display: applePay ? "block" : "none",
      opacity: applePay ? 1 : 0.5,
      pointerEvents: applePay ? "auto" : "none",
      visibility: applePay ? "visible" : "hidden"
    },
    id: id,
    ref: containerRef
  }));
}

export { ApplePay as default };